import {
  LayoutDashboard, Activity, Building2, Store, Users, ShieldAlert, BadgeCheck,
  ClipboardList, FileText, UserPlus, CalendarCheck, CheckCircle2, Rocket,
  Quote, ShoppingCart, FileSignature, Receipt, CreditCard, FolderOpen, Clock,
  Bell, Mail, LayoutTemplate, Megaphone, BarChart3, TrendingUp, PieChart,
  DollarSign, FileBarChart, Settings, ScrollText, ShieldCheck, LifeBuoy,
  Search, Plus, Briefcase, MessageSquare, Award, UserCheck,
} from "lucide-react";

// Each group: { title, items: [{ label, to, icon }] }
const P = (to) => `/app/${to}`;

export const NAVIGATION = {
  super_admin: [
    { title: "Overview", items: [
      { label: "Command Center", to: P("overview"), icon: LayoutDashboard },
      { label: "Business Analytics", to: P("analytics"), icon: BarChart3 },
      { label: "Activity Center", to: P("activity"), icon: Activity },
    ]},
    { title: "Partners", items: [
      { label: "All Partners", to: P("partners"), icon: Building2 },
      { label: "Clients", to: P("partners?type=client"), icon: Building2 },
      { label: "Vendors", to: P("partners?type=vendor"), icon: Store },
      { label: "Staffing Companies", to: P("partners?type=staffing"), icon: Users },
      { label: "Pending Approvals", to: P("approvals"), icon: ShieldAlert },
      { label: "Verification Queue", to: P("verification"), icon: BadgeCheck },
    ]},
    { title: "Operations", items: [
      { label: "Requirements", to: P("requirements"), icon: ClipboardList },
      { label: "RFQs / RFPs", to: P("rfqs"), icon: FileText },
      { label: "Candidate Submissions", to: P("submissions"), icon: UserPlus },
      { label: "Interviews", to: P("interviews"), icon: CalendarCheck },
      { label: "Selections", to: P("selections"), icon: CheckCircle2 },
    ]},
    { title: "Procurement", items: [
      { label: "Quotations", to: P("quotations"), icon: Quote },
      { label: "Purchase Orders", to: P("purchase-orders"), icon: ShoppingCart },
      { label: "Contracts", to: P("contracts"), icon: FileSignature },
      { label: "Invoices", to: P("invoices"), icon: Receipt },
      { label: "Payments", to: P("payments"), icon: CreditCard },
    ]},
    { title: "Agreements", items: [
      { label: "Agreements", to: P("agreements"), icon: FileSignature },
      { label: "Clause Library", to: P("agreement-clauses"), icon: ScrollText },
      { label: "Agreement Templates", to: P("agreement-templates"), icon: LayoutTemplate },
    ]},
    { title: "Documents", items: [
      { label: "Document Center", to: P("documents"), icon: FolderOpen },
      { label: "Expiring Documents", to: P("expiring-documents"), icon: Clock },
    ]},
    { title: "Communications", items: [
      { label: "Notifications", to: P("notifications"), icon: Bell },
      { label: "Email Center", to: P("email-center"), icon: Mail },
      { label: "Email Templates", to: P("templates"), icon: LayoutTemplate },
    ]},
    { title: "Analytics", items: [
      { label: "Partner Performance", to: P("partner-performance"), icon: TrendingUp },
      { label: "Reports", to: P("reports"), icon: FileBarChart },
    ]},
    { title: "Administration", items: [
      { label: "Users", to: P("users"), icon: Users },
      { label: "Partner Onboarding", to: P("partner-onboarding"), icon: ShieldCheck },
      { label: "Audit Logs", to: P("audit-logs"), icon: ScrollText },
      { label: "Company Profile", to: P("company-profile"), icon: Building2 },
      { label: "System Settings", to: P("settings"), icon: Settings },
    ]},
  ],
  client: [
    { title: "Overview", items: [
      { label: "Dashboard", to: P("overview"), icon: LayoutDashboard },
      { label: "Activity", to: P("activity"), icon: Activity },
    ]},
    { title: "Requirements", items: [
      { label: "All Requirements", to: P("requirements"), icon: ClipboardList },
      { label: "Create Requirement", to: P("requirement-new"), icon: Plus },
    ]},
    { title: "Procurement", items: [
      { label: "RFQs", to: P("rfqs"), icon: FileText },
      { label: "Quotations", to: P("quotations"), icon: Quote },
      { label: "Purchase Orders", to: P("purchase-orders"), icon: ShoppingCart },
      { label: "Contracts", to: P("contracts"), icon: FileSignature },
    ]},
    { title: "Staffing", items: [
      { label: "Candidate Submissions", to: P("submissions"), icon: UserPlus },
      { label: "Interviews", to: P("interviews"), icon: CalendarCheck },
    ]},
    { title: "Vendors", items: [
      { label: "Vendor Network", to: P("marketplace"), icon: Store },
    ]},
    { title: "Finance", items: [
      { label: "Invoices", to: P("invoices"), icon: Receipt },
      { label: "Payments", to: P("payments"), icon: CreditCard },
    ]},
    { title: "Workspace", items: [
      { label: "Calendar", to: P("calendar"), icon: CalendarCheck },
      { label: "Documents", to: P("documents"), icon: FolderOpen },
      { label: "Notifications", to: P("notifications"), icon: Bell },
      { label: "Support", to: P("support"), icon: LifeBuoy },
    ]},
  ],
  vendor: [
    { title: "Overview", items: [
      { label: "Dashboard", to: P("overview"), icon: LayoutDashboard },
      { label: "Activity", to: P("activity"), icon: Activity },
    ]},
    { title: "Business", items: [
      { label: "Company Profile", to: P("profile"), icon: Briefcase },
      { label: "Business Performance", to: P("analytics"), icon: BarChart3 },
    ]},
    { title: "Opportunities", items: [
      { label: "RFQ Invitations", to: P("rfqs"), icon: FileText },
      { label: "Submitted Quotations", to: P("quotations"), icon: Quote },
    ]},
    { title: "Procurement", items: [
      { label: "Purchase Orders", to: P("purchase-orders"), icon: ShoppingCart },
      { label: "Contracts", to: P("contracts"), icon: FileSignature },
    ]},
    { title: "Finance", items: [
      { label: "Invoices", to: P("invoices"), icon: Receipt },
      { label: "Payments", to: P("payments"), icon: CreditCard },
    ]},
    { title: "Workspace", items: [
      { label: "Calendar", to: P("calendar"), icon: CalendarCheck },
      { label: "Documents", to: P("documents"), icon: FolderOpen },
      { label: "Notifications", to: P("notifications"), icon: Bell },
      { label: "Support", to: P("support"), icon: LifeBuoy },
    ]},
  ],
  staffing: [
    { title: "Overview", items: [
      { label: "Dashboard", to: P("overview"), icon: LayoutDashboard },
      { label: "Activity", to: P("activity"), icon: Activity },
    ]},
    { title: "Requirements", items: [
      { label: "Assigned Requirements", to: P("requirements"), icon: ClipboardList },
    ]},
    { title: "Talent Operations", items: [
      { label: "Candidate Database", to: P("candidates"), icon: Users },
      { label: "Submissions", to: P("submissions"), icon: UserPlus },
      { label: "Interviews", to: P("interviews"), icon: CalendarCheck },
      { label: "Selections", to: P("selections"), icon: Award },
    ]},
    { title: "Analytics", items: [
      { label: "Recruitment Analytics", to: P("analytics"), icon: BarChart3 },
    ]},
    { title: "Contracts & Finance", items: [
      { label: "Contracts", to: P("contracts"), icon: FileSignature },
      { label: "Invoices", to: P("invoices"), icon: Receipt },
      { label: "Payments", to: P("payments"), icon: CreditCard },
    ]},
    { title: "Workspace", items: [
      { label: "Calendar", to: P("calendar"), icon: CalendarCheck },
      { label: "Documents", to: P("documents"), icon: FolderOpen },
      { label: "Notifications", to: P("notifications"), icon: Bell },
      { label: "Support", to: P("support"), icon: LifeBuoy },
    ]},
  ],
};

export const DASHBOARD_NAME = {
  super_admin: "VS Command Center",
  client: "Client Workspace",
  vendor: "Vendor Workspace",
  staffing: "Staffing Command Center",
};
